export default __webpack_public_path__ + "static/media/Inter-Regular.b3b207f0.ttf";